import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Zap, Settings2, Trash2, Plus, Save, X } from "lucide-react";
import { adminApi } from "@/lib/api";

export const fillReply = (text, user) => text.replace(/\{nome\}/g, (user?.name || "").trim().split(/\s+/)[0] || "");

const field = "w-full bg-[#f4f6f7] border border-[#d5dbde] text-[#2B3036] text-sm px-2 py-1.5 outline-none focus:border-[#E0262C]";

const Editor = ({ r, onSaved, onDeleted }) => {
  const [f, setF] = useState({ title: r?.title || "", text: r?.text || "" });
  const save = async () => {
    try {
      const d = r ? await adminApi.editQuickReply(r.id, f) : await adminApi.addQuickReply(f);
      onSaved(d, !r);
      if (!r) setF({ title: "", text: "" });
      toast.success("Risposta salvata");
    } catch (e) { toast.error(e?.response?.data?.detail?.[0]?.msg || "Compila titolo e testo"); }
  };
  return (
    <div data-testid={`qr-editor-${r?.id || "new"}`} className="border border-[#d5dbde] p-3 space-y-2">
      <input data-testid={`qr-title-${r?.id || "new"}`} value={f.title} maxLength={60} placeholder="Titolo (es. Report pronto)" onChange={(e) => setF({ ...f, title: e.target.value })} className={field} />
      <textarea data-testid={`qr-text-${r?.id || "new"}`} value={f.text} rows={2} maxLength={2000} placeholder="Testo… usa {nome} per il nome del cliente" onChange={(e) => setF({ ...f, text: e.target.value })} className={`${field} resize-none`} />
      <div className="flex gap-2">
        <button data-testid={`qr-save-${r?.id || "new"}`} onClick={save} className="inline-flex items-center gap-1 text-[10px] font-mono uppercase aurora-gradient text-white px-2 py-1">
          {r ? <Save className="w-3 h-3" /> : <Plus className="w-3 h-3" />} {r ? "Salva" : "Aggiungi"}
        </button>
        {r && <button data-testid={`qr-delete-${r.id}`} onClick={() => window.confirm(`Eliminare "${r.title}"?`) && adminApi.deleteQuickReply(r.id).then(() => onDeleted(r.id))}
          className="inline-flex items-center gap-1 text-[10px] font-mono uppercase border border-[#d5dbde] hover:border-[#ef4444] hover:text-[#ef4444] px-2 py-1"><Trash2 className="w-3 h-3" /> Elimina</button>}
      </div>
    </div>
  );
};

const Manager = ({ replies, setReplies, onClose }) => (
  <div data-testid="qr-manager" className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center p-4" onClick={onClose}>
    <div className="bg-white border border-[#d5dbde] w-full max-w-xl max-h-[85vh] overflow-y-auto p-5 space-y-3" onClick={(e) => e.stopPropagation()}>
      <div className="flex items-center justify-between">
        <h3 className="font-display text-xl text-[#2B3036]">Risposte rapide</h3>
        <button data-testid="qr-manager-close" onClick={onClose} className="text-[#5b6168] hover:text-[#E0262C]"><X className="w-5 h-5" /></button>
      </div>
      <p className="text-xs text-[#6b7280] font-mono">Il segnaposto {"{nome}"} viene sostituito con il nome del cliente.</p>
      {replies.map((r) => (
        <Editor key={r.id} r={r} onSaved={(d) => setReplies((p) => p.map((x) => (x.id === d.id ? { ...x, ...d } : x)))}
          onDeleted={(id) => setReplies((p) => p.filter((x) => x.id !== id))} />
      ))}
      <div className="text-[10px] uppercase font-mono text-[#6b7280] pt-2">Nuova risposta</div>
      <Editor onSaved={(d) => setReplies((p) => [...p, d])} />
    </div>
  </div>
);

export const QuickReplies = ({ user, onPick }) => {
  const [replies, setReplies] = useState([]);
  const [manage, setManage] = useState(false);
  useEffect(() => { adminApi.quickReplies().then((d) => setReplies(d.replies)).catch(() => {}); }, []);
  return (
    <div data-testid="quick-replies" className="flex items-center gap-1.5 px-3 py-2 border-t border-[#d5dbde] overflow-x-auto">
      <Zap className="w-3.5 h-3.5 text-[#E0262C] flex-shrink-0" />
      {replies.map((r) => (
        <button key={r.id} data-testid={`qr-chip-${r.id}`} onClick={() => onPick(fillReply(r.text, user))} title={r.text}
          className="flex-shrink-0 text-[11px] border border-[#d5dbde] text-[#3f454c] hover:border-[#E0262C] hover:text-[#E0262C] px-2 py-1 whitespace-nowrap">{r.title}</button>
      ))}
      <button data-testid="qr-manage" onClick={() => setManage(true)} title="Gestisci risposte rapide"
        className="ml-auto flex-shrink-0 text-[#6b7280] hover:text-[#E0262C] p-1"><Settings2 className="w-4 h-4" /></button>
      {manage && <Manager replies={replies} setReplies={setReplies} onClose={() => setManage(false)} />}
    </div>
  );
};
